// Visual V3 test mode with fictional fixtures: only a local dev server on localhost with REACT_APP_V3_FIXTURES=1.
// Production builds drop it (NODE_ENV), preview hosts never match the host check.
export const FIXTURE_MODE =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_V3_FIXTURES === "1" &&
  typeof window !== "undefined" &&
  /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
